module.exports = __webpack_public_path__ + "static/media/hand-middle-finger.97bbdef9.svg";